"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Zoom.default;
  }
});

var _Zoom = _interopRequireDefault(require("./Zoom"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Zoom/index.js
// module id = 472
// module chunks = 226573449209678